import React from 'react';
import { styled } from '@mui/material/styles';
import { Paper, Box, Grid, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ChanceStatusIcon from './ChanceStatusIcon';
import { getNumberComma } from '../../../utils/numberUtils';
import {
  useMobilePageHeader,
  useMobilePageHeaderContext,
} from '../../../hooks/useMobilePageHeader';

const WhiteIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.getContrastText(
      theme.palette.background.paper,
    ),
  },
}));

const WhiteTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.background.paper,
}));

const ChanceInfo = ({ chance, handleGoBack }) => {
  const { scrollContentToTop } = useMobilePageHeaderContext() || {};

  // xs: 제목/뒤로가기/"번호 · 단계"를 모바일 상단 앱바에 합쳐서 보여준다
  // (이 다크 헤더 자체는 xs에서 숨김). 단계 텍스트는 탭하면 맨 위로 스크롤한다.
  useMobilePageHeader({
    title: chance?.cstNm,
    captionKey: `${chance?.prjNo || ''}|${chance?.cstStatus || ''}`,
    onBack: handleGoBack,
    caption: (
      <Typography
        variant="caption"
        component="div"
        color="text.secondary"
        noWrap
        sx={{ width: '100%' }}
      >
        {chance?.prjNo}
        {chance?.prjNo && chance?.cstStatus ? ' · ' : ''}
        <Box
          component="span"
          onClick={(e) => {
            e.stopPropagation();
            scrollContentToTop?.();
          }}
          sx={{ color: 'primary.main', fontWeight: 500 }}
        >
          {chance?.cstStatus}
        </Box>
        {chance?.cstStatus ? ' 단계' : ''}
      </Typography>
    ),
  });

  return (
    <Paper
      sx={{
        mx: { xs: 0, sm: 2 },
        position: { xs: 'sticky', sm: 'static' },
        top: 0,
        zIndex: { xs: 2, sm: 'auto' },
      }}
    >
      {/* sm+: 데스크톱 압축 헤더 카드(ChanceStepperContainer)로 대체되어 항상 숨김.
          xs는 이 Box가 원래도 'none' 이었다(모바일 상단 앱바가 대신한다) — 그대로 유지. */}
      <Box
        sx={{
          display: 'none',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          backgroundColor: '#424242',
        }}
      >
        <Box sx={{ p: 1 }}>
          <WhiteIconButton size="small" onClick={handleGoBack}>
            <ArrowBackIcon aria-label="goBack" />
          </WhiteIconButton>
        </Box>
        <Box
          sx={{
            py: 1,
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <ChanceStatusIcon chance={chance} />
          <Box sx={{ ml: 2 }}>
            <WhiteTypography variant="subtitle2" component="div">
              현재 단계: {chance?.cstStatus}
            </WhiteTypography>
            <WhiteTypography variant="subtitle1" component="div">
              {chance.cstNm}
              <Typography component="span" variant="caption" sx={{ ml: 1, opacity: 0.7 }}>
              {chance?.prjNo}
            </Typography>
            <Typography component="span" variant="caption" sx={{ ml: 1, opacity: 0.7 }}>
              {chance?.customerNm}
            </Typography>
            </WhiteTypography>

          </Box>
        </Box>
      </Box>
      {/* <Box sx={{ px: 2, py: 2 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              프로젝트 번호
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              매출처명
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              매출(수금)예정일
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="subtitle2" component="div">
              예상 금액
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {chance?.prjNo}
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {chance?.vendorCmpNm}
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {chance.expDay ? chance?.expDay : `-`}
            </Typography>
          </Grid>
          <Grid item xs={3} align="center">
            <Typography variant="body2" component="div">
              {getNumberComma(chance.expSales)}
            </Typography>
          </Grid>
        </Grid>
      </Box> */}
    </Paper>
  );
};

export default ChanceInfo;
